// Mirrors backend core.calc_shipping (backend stays authoritative).
export const zonesOf = (settings) => settings?.shipping_rates?.uae_zones || [];

export const calcShippingAed = (settings, { country, zone, method, qty, subtotalAed }) => {
  const r = settings?.shipping_rates;
  if (!r) return null;
  const thr = Number(settings.free_shipping_threshold) || 0;
  let fee;
  if (country === "United Arab Emirates") {
    const z = (r.uae_zones || []).find((x) => x.key === zone);
    if (!z) return null;
    fee = Number(z.price);
  } else {
    const m = r.gcc?.[method];
    if (!m) return null;
    const kg = Math.max(1, Math.ceil(Math.round(qty * Number(r.unit_weight_kg || 0.5) * 1000) / 1000));
    fee = Number(m.first) + Number(m.extra) * (kg - 1);
  }
  return thr && subtotalAed >= thr ? 0 : fee;
};

export const courierOf = (settings, country) =>
  (country === "United Arab Emirates" ? settings?.shipping_rates?.uae_courier : settings?.shipping_rates?.gcc_courier) || "";
